"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getHeaderAndFooterData = getHeaderAndFooterData;
exports.getHeaderNavData = getHeaderNavData;
const utils_1 = require("./utils");
/**
 * getHeaderAndFooterData()
 *
 * This functions fetches header and footer data from the monolith
 *
 * @param options.locale - Locale to request data with
 * @param options.monolithBaseUrl - Base URL of monolith server to request data from
 * @param req
 * @returns
 */
function getHeaderAndFooterData(_a, req_1) {
    return __awaiter(this, arguments, void 0, function* ({ locale, monolithBaseUrl }, req) {
        var _b, _c;
        // Create fetch options
        const fetchOptions = (0, utils_1.defaultStaticOptions)();
        const forwardedHeaders = req ? (0, utils_1.forwardHeaders)(req) : {};
        fetchOptions.headers = Object.assign(Object.assign({}, fetchOptions.headers), forwardedHeaders);
        // Read `accessToken` from request to discern if user is logged in
        const accessToken = (_c = (_b = req === null || req === void 0 ? void 0 : req.cookies) === null || _b === void 0 ? void 0 : _b.access_token) !== null && _c !== void 0 ? _c : '';
        // Constructor params
        const params = {
            header: 'true',
            footer: 'true',
            locale,
            // `for_public_caching` is implemented in Django API endpoint to signal fetching of user-specific data
            for_public_caching: accessToken ? 'false' : 'true',
        };
        // Construct `baseURL`
        let baseUrl = monolithBaseUrl;
        if (req) {
            baseUrl = (0, utils_1.getBaseUrl)(req, monolithBaseUrl);
        }
        // Construct URL
        const url = `${baseUrl}/api-2.0/contexts/me/?${new URLSearchParams(params)}`;
        // Fetch data
        const response = yield fetch(url, fetchOptions);
        if (!response.ok) {
            throw new Error(`Response error in getHeaderAndFooterData(): ${response.status}`);
        }
        const responseData = yield response.json();
        return responseData;
    });
}
/**
 * getHeaderNavData()
 *
 * Gets navigation data for header browse menu.  Part of `header` application context.
 *
 * @param options.isUFB - Which navigation request to fetch
 * @param options.locale - Locale to request
 * @param options.monolithBaseUrl - Base Url of monolith server to request data from
 * @param req - client request
 * @returns
 */
function getHeaderNavData(_a, req_1) {
    return __awaiter(this, arguments, void 0, function* ({ isUFB, locale, monolithBaseUrl }, req) {
        var _b, _c;
        // Create fetch options
        const fetchOptions = (0, utils_1.defaultStaticOptions)();
        fetchOptions.headers = Object.assign(Object.assign({}, fetchOptions.headers), (0, utils_1.forwardHeaders)(req));
        // Construct params
        const navList = isUFB ? 'ufb-main' : 'ud-main';
        const params = {
            list_ids: navList,
            locale,
        };
        // Construct `baseURL`
        const baseUrl = (0, utils_1.getBaseUrl)(req, monolithBaseUrl);
        // Construct url
        const url = `${baseUrl}/api-2.0/structured-data/navigation-lists/?${new URLSearchParams(params)}`;
        // Fetch data
        const response = yield fetch(url, fetchOptions);
        // Throw an error if there is a problem with the request.  That means we won't be able to render anything anyway and should just 500 overall.
        if (!response.ok) {
            throw new Error(`Response error in getHeaderNavData(): ${response.status}`);
        }
        const responseData = yield response.json();
        // Attempt to resolve some data in any case
        const navListResponse = (_c = (_b = responseData[navList]) !== null && _b !== void 0 ? _b : responseData['ufb-main']) !== null && _c !== void 0 ? _c : responseData['ud-main'];
        return navListResponse.items;
    });
}
//# sourceMappingURL=header-and-footer-data.js.map